var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRichtext)?_c('div',{staticClass:"base-richtext"},[_c('rich-text-renderer',{attrs:{"document":_vm.doc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }